import xeroxApi from '../axios/xeroxApi';
class JobService {
    async getParentJobList(req) {
        return Promise.resolve(xeroxApi.post(`jobs/all/`, req));
    }

    async getParentWatchJobList(req) {
        return Promise.resolve(xeroxApi.post(`jobs/watchlists/`, req));
    }

    async getParentFavouriteJobList(req) {
        return Promise.resolve(xeroxApi.post(`jobs/favourites/`, req));
    }

    async getParentErrorJobList(req) {
        return Promise.resolve(xeroxApi.post(`jobs/errors/`, req));
    }

    // For get jobs records wedgit 
    async getJobsRecordsWedgit(req) {
        return Promise.resolve(xeroxApi.post(`jobs/records/`, req));
    }

    async getChildJobsByParentId(req) {
        return Promise.resolve(xeroxApi.post(`jobs/children/`, req));
    }

    async getJobDetails(req) {
        return Promise.resolve(xeroxApi.post(`jobs/detail/`, req));
    }

    async addJobsInWatchList(req) {
        return Promise.resolve(xeroxApi.post(`jobs/watchlist/add/`, req));
    }

    async getUserWatchList(req) {
        return Promise.resolve(xeroxApi.post(`jobs/watchlist/all/`, req));
    }

    async getChannelFilterList(req) {
        return Promise.resolve(xeroxApi.post(`jobs/deliverychannels/`, req));
    }

    async getFavouritesJobList(req) {
        return Promise.resolve(xeroxApi.post(`jobs/categories/`, req));
    }

    async addFavouriteJobList(req) {
        return Promise.resolve(xeroxApi.post(`jobs/favourites/add/`, req));
    }

    async fetchUserFavouritesJobs(req) {
        return Promise.resolve(xeroxApi.post(`jobs/user/favourites`, req));
    }

    // SLA PAGE API
    async getSlaJobList(req) {
        return Promise.resolve(xeroxApi.post(`jobs/slajoblist/`, req));
    }

    async getSlaListData(req) {
        return Promise.resolve(xeroxApi.post(`jobs/slalistdata/`, req));
    }

    // async getSlaMemberList(req) {
    //     return Promise.resolve(xeroxApi.post(`jobs/slamemberlist/`, req));
    // }

}

export default JobService;